import React, {useState, useEffect, useRef} from 'react';
import moment from 'moment';
import '../App.css';

import { Box, Grid, Paper, Typography, IconButton, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, InputAdornment, Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles, withStyles } from "@material-ui/core/styles";
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import PullToRefresh from 'react-simple-pull-to-refresh';
import Rating, { IconContainerProps } from '@material-ui/lab/Rating';
import SentimentVeryDissatisfiedIcon from '@material-ui/icons/SentimentVeryDissatisfied';
import SentimentSatisfiedIcon from '@material-ui/icons/SentimentSatisfied';
import SentimentSatisfiedAltIcon  from '@material-ui/icons/SentimentSatisfiedAltOutlined';
// import StarBorderIcon from '@material-ui/icons/StarBorder';
// import StarIcon from '@material-ui/icons/Star';
import RatingIcon from '../assets/rating.png'; 

const useStyles = makeStyles(theme => ({
  red_text: {
    color: "#ff0000"
  },
  green_text: {
    color: "#009900"
  },
  grey_text: {
    color: "#666666"
  },
  big_text: {
    fontSize: 24
  }
}));

const CustomRating = ({id, ratings, setRatings, ...props}) => {
  // const [value, setValue] = useState(2); // Default rating value
  const handleRatingChange = (event, newRating) => {
    if (newRating !== null && newRating > 0) {
      setRatings(prevRatings => ({
        ...prevRatings,
        [id]: newRating // Update the specific rating by its identifier
      }));
    }
  };

  // Function to determine the icon based on the rating value
  const getIcon = (iconValue, currentValue) => {

    if (iconValue === currentValue) {
      // Highlight the selected icon
      switch (iconValue) {
        case 1:
          return <SentimentVeryDissatisfiedIcon style={{ color: '#ff0000' }} />;
        case 2:
          return <SentimentSatisfiedIcon style={{ color: '#fdb32a' }} />;
        case 3:
          return <SentimentSatisfiedAltIcon style={{ color: '#009900' }} />;
        default:
          return null;
      }
    } else {
      // Display the icon without highlight
      switch (iconValue) {
        case 1:
          return <SentimentVeryDissatisfiedIcon style={{ color: 'grey' }} />;
        case 2:
          return <SentimentSatisfiedIcon style={{ color: 'grey' }} />;
        case 3:
          return <SentimentSatisfiedAltIcon style={{ color: 'grey' }} />;
        default:
          return null;
      }
    }
  };

  return (
    <Rating
      {...props}
      id={id}
      name={id}
      value={ratings[id] || 0}
      onChange={handleRatingChange}
      getLabelText={(value) => {
        // Provide labels for accessibility
        switch (value) {
          case 1:
            return 'Very Dissatisfied';
          case 2:
            return 'Satisfied';
          case 3:
            return 'Very Satisfied';
          default:
            return '';
        }
      }}
      IconContainerComponent={({ value: iconValue, ...other }) => {
        return (
          <span {...other}>
            {getIcon(iconValue, ratings[id])}
          </span>
        );
      }}
      // Define the number of icons you want to display
      max={3}
      size="large"
    />
  );
};

function parseTextToIcons(text) {
  const iconMap = {
    ":1": <SentimentVeryDissatisfiedIcon style={{ color: '#ff0000', verticalAlign: 'text-bottom' }} />,
    ":2": <SentimentSatisfiedIcon style={{ color: '#fdb32a', verticalAlign: 'text-bottom' }} />,
    ":3": <SentimentSatisfiedAltIcon style={{ color: '#009900', verticalAlign: 'text-bottom' }} />,
    ":n": <br/>,
  };

  // Split the text by spaces to handle each word separately
  const words = text.split(/\s+/).map((word) => {
    // If the word matches a code in the iconMap, return the icon component
    return iconMap[word] || word;
  });

  // Return the array of words and icon components as inline elements
  return words.map((word, index) => <React.Fragment key={index}>{word}</React.Fragment>);
}

const StockItem = (props) => {

  const classes = useStyles();

  return (
    <Grid item xs={12}>
      <Paper elevation={2}>
        <Box p={1}>
          <Grid container justifyContent="space-around" spacing={1}>
              {DummyField(35, "类型", props.formData.value > 0 ? "收入" : "支出", props.formData.value > 0 ? classes.green_text : classes.red_text)}
              {DummyField(82, "项目", parseTextToIcons(props.formData.name))}
              {DummyField(55, "数额", "¥ " + Math.abs(props.formData.value).toFixed(2), props.formData.value > 0 ? classes.green_text : classes.red_text)}
              {DummyField(45, "日期", props.formData.time.substring(5, 10))}
              {DummyField(45, "结余", "¥ " + parseInt(props.formData.balance))}
          </Grid>
        </Box>
      </Paper>
    </Grid>
    );
}

const DummyField = (_width, label, value, textClassName=null) => {

  return (
    <Grid item>
      <Box width={_width}>
        <Grid container direction="column">
          <Grid item>
            <Typography className="label" style={{fontSize:10}} >{label}</Typography>
          </Grid>
          <Grid item>
            <Typography className={textClassName}>{value}</Typography>
          </Grid>
        </Grid>
      </Box>
    </Grid>
  );
}

function PocketDetails() {

    const [record, setRecord] = useState(null)
    const [openBuy, setOpenBuy] = useState(false);
    const [buyOrAward, setBuyOrAward] = useState(false);

    const [openRating, setOpenRating] = useState(false);
    const [ratings, setRatings] = useState({
      // Initialize the state with identifiers for each rating component
      rating1: 2,
      rating2: 2,
      rating3: 2,
      rating4: 2,
      rating5: 2,
      // ... more ratings if needed
    });

    const rating_time_ref = useRef("");
    const rating_password_ref = useRef("");


    const buy_value_ref = useRef(0);
    const buy_name_ref = useRef("");
    const buy_time_ref = useRef("");
    const award_password_ref = useRef("");

    const [openAlert, setOpenAlert] = useState(false);
    const alert_severity_ref = useRef("");
    const alert_message_ref = useRef("");


    useEffect(() => {
        document.title = "Sherlock's Pocket Money";

        fetch("/api/sherlock/record")
        .then(res => res.json())
        .then((result) => {
          if (result.success)
            setRecord(result.data);
          },
          (error) => {
            console.log(error);
          }
        );
    }, [])

    const handleRefresh = () => {
      return new Promise((resolve, reject) => {
        fetch("/api/sherlock/record")
        .then(res => res.json())
        .then((result) => {
          if (result.success)
          {
            setRecord(result.data);
            resolve();
          }
          else
          {
            reject();
          }
          },
          (error) => {
            console.log(error);
            reject();
          }
        );
      });
    };

    const OpenBuyDialog = () => {
      setOpenBuy(true);
    };

    const CloseBuyDailog = () => {
      setOpenBuy(false);
      setBuyOrAward(false);
    };

    const SubmitBuy = () => {

      let record = {}
      record.name = buy_name_ref.current.value.trim(); 
      record.value = parseFloat(buy_value_ref.current.value);
      record.time = buy_time_ref.current.value;

      if (record.name === "")
      {
        AlertMessage("warning", "项目名称不能为空");
        return;
      }
      if (!buyOrAward && (!record.value || record.value <= 0))
      {
        AlertMessage("warning", "花费数额需要为正数");
        return;
      }
      if (record.time === "")
      {
        AlertMessage("warning", "日期不能为空");
        return;
      }
      if (award_password_ref.current.value !== "3518401" && award_password_ref.current.value !== "816312" )
      {
        AlertMessage("warning", "密码不正确");
        return;
      }

      if (!buyOrAward)
        record.value = -record.value;

      fetch("/api/sherlock/add", {
        method: 'POST',
        body: JSON.stringify(record),
        headers: {
          'content-type': 'application/json'
        }
      })
      .then(res => res.json())
      .then(result => {
        if (result.success)
          setRecord(result.data);
      });

      setOpenBuy(false);
      setBuyOrAward(false);
    };

    const OpenRatingDialog = () => {
      setOpenRating(true);
    }

    const CloseRatingDailog = () => {
      setOpenRating(false);
    };

    function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    function mapAndClampNumberToFloat(number) {
      const clampedNumber = clamp(number, 7, 14);
      // Map the number from the range 7-14 to the range 0-3
      const mappedNumber = ((clampedNumber - 7) / (14 - 7)) * (3 - 0);
      // Round the result to 2 decimal places
      return Math.round(mappedNumber * 100) / 100;
    }

    const SubmitRating = () => {


      const date = new Date(rating_time_ref.current.value);
      const dayInChinese = date.toLocaleString('zh-CN', { weekday: 'short' });

      // Convert the ratings object to the desired string format
      const ratingsText = `${dayInChinese} :${ratings.rating1} :${ratings.rating2} :n :${ratings.rating3} :${ratings.rating4} :${ratings.rating5}`;
      console.log(ratingsText);
      const ratingsSum = Object.values(ratings).reduce((sum, currentRating) => sum + currentRating, 0);
      const awardCoin = mapAndClampNumberToFloat(ratingsSum);
      console.log(ratingsSum, awardCoin);

      let record = {}
      record.name = ratingsText;
      record.value = awardCoin;
      record.time = rating_time_ref.current.value;

      if (record.time === "")
      {
        AlertMessage("warning", "日期不能为空");
        return;
      }
      if (rating_password_ref.current.value !== "3518401" && rating_password_ref.current.value !== "816312")
      {
        AlertMessage("warning", "密码不正确");
        return;
      }

      fetch("/api/sherlock/add", {
        method: 'POST',
        body: JSON.stringify(record),
        headers: {
          'content-type': 'application/json'
        }
      })
      .then(res => res.json())
      .then(result => {
        if (result.success)
          setRecord(result.data);
      });

      setOpenRating(false);
    }

    const AlertMessage = (severity, message) => {
      alert_severity_ref.current = severity;
      alert_message_ref.current = message;
      setOpenAlert(true);
    };

    const handleAlertClose = (event, reason) => {
      if (reason === 'clickaway')
        return;
      setOpenAlert(false);
    };

    return (
      <React.Fragment>
        <PullToRefresh onRefresh={handleRefresh} pullingContent="">
          <Box p={2} pt={2}>
            <Grid container spacing={1}>
                <Grid item>
                  <Paper elevation={2}>
                    <Box p={1}>
                      <Grid container spacing={1}>
                        <Grid item>
                          <Typography>Sherlock's Pocket Money</Typography>
                        </Grid>
                      </Grid>
                      <Grid container spacing={2}>
                        <Grid item>
                          <Typography style={{fontSize:24, color:"#666666"}}>余额</Typography>
                        </Grid>
                        <Grid item>
                          <Typography style={{fontSize:24}}>¥ {record && record.balance.toFixed(2)}</Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  </Paper>
                </Grid>
                <Grid item>
                  <Box mt={3}>
                    <IconButton size="medium" onClick={OpenBuyDialog}>
                      <AddShoppingCartIcon fontSize="large" />
                    </IconButton>
                    <IconButton size="medium" onClick={OpenRatingDialog}>
                      <img src={RatingIcon} alt="RatingIcon" style={{ width: 36, height: 36 }} />
                    </IconButton>
                  </Box>
                </Grid>
            </Grid>
            <Box p={1}></Box>
            <Grid container justifyContent="space-around" spacing={2}>
              {record && record.history.map((item, i) => (
                <StockItem formData={item} key={i}/>
                ))
              }
            </Grid>
            <Dialog open={openBuy} onClose={CloseBuyDailog} aria-labelledby="form-dialog-title">
              <DialogTitle id="form-dialog-title"><Button onClick={ () => setBuyOrAward(!buyOrAward) }>{buyOrAward ? '奖励' : '买东西' }</Button></DialogTitle>
              <DialogContent>
                {openBuy &&
                  <DialogContent>
                    <Box width={180}>
                      <Grid container spacing={2} direction="column">
                        <Grid item>
                          <Box width={160}>
                            <TextField
                              autoFocus
                              autoComplete='on'
                              id="buy_name"
                              label="项目"
                              size="small"
                              margin="none"
                              inputRef={buy_name_ref}
                            />
                          </Box>
                        </Grid>
                        <Grid item>
                          <Box width={160}>
                            <TextField
                              autoComplete='off'
                              id="buy_value"
                              label={buyOrAward ? "奖励" : "花费"}
                              size="small"
                              type="number"
                              margin="none"
                              inputRef={buy_value_ref}
                              InputProps={{
                                startAdornment: <InputAdornment position="start">¥</InputAdornment>
                              }}
                            />
                          </Box>
                        </Grid>
                        <Grid item>
                          <Box width={160}>
                            <TextField
                              autoComplete='off'
                              id="award_password_value"
                              label="密码"
                              size="small"
                              type="password"
                              margin="none"
                              inputRef={award_password_ref}
                            />
                          </Box>
                        </Grid>
                        <Grid item>
                          <Box width={160}>
                            <TextField
                              autoComplete='on'
                              id="buy_date"
                              label="日期"
                              size="small"
                              margin="none"
                              inputRef={buy_time_ref}
                              defaultValue = {moment().format("YYYY-MM-DD")}
                            />
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  </DialogContent>
                }
              </DialogContent>
              <DialogActions>
                <Button onClick={CloseBuyDailog} color="primary">
                  Cancel
                </Button>
                <Button onClick={SubmitBuy} color="primary">
                  Submit
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog open={openRating} onClose={CloseRatingDailog} aria-labelledby="form-dialog-title">
              <DialogTitle id="form-dialog-title">学习评价</DialogTitle>
              <DialogContent>
                {openRating &&
                  <DialogContent>
                    <Box width={180}>
                      <Grid container spacing={2} direction="column">
                        <Grid item>
                          <Box width={160}>
                            <TextField
                              autoComplete='on'
                              id="buy_date"
                              label="日期"
                              size="small"
                              margin="none"
                              inputRef={rating_time_ref}
                              defaultValue = {moment().format("YYYY-MM-DD")}
                            />
                          </Box>
                        </Grid>
                        <Grid item>
                          <Grid container spacing={2}>
                            <Grid item>
                              <Typography component="legend">在校表现佳</Typography>
                            </Grid>
                            <Grid item>
                              <CustomRating id="rating1" ratings={ratings} setRatings={setRatings} />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item>
                          <Grid container spacing={2}>
                            <Grid item>
                              <Typography component="legend">整理无遗落</Typography>
                            </Grid>
                            <Grid item>
                              <CustomRating id="rating2" ratings={ratings} setRatings={setRatings} />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item>
                          <Grid container spacing={2}>
                            <Grid item>
                              <Typography component="legend">回家要安全</Typography>
                            </Grid>
                            <Grid item>
                              <CustomRating id="rating3" ratings={ratings} setRatings={setRatings} />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item>
                          <Grid container spacing={2}>
                            <Grid item>
                              <Typography component="legend">作业完成早</Typography>
                            </Grid>
                            <Grid item>
                              <CustomRating id="rating4" ratings={ratings} setRatings={setRatings} />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item>
                          <Grid container spacing={2}>
                            <Grid item>
                              <Typography component="legend">作业质量优</Typography>
                            </Grid>
                            <Grid item>
                              <CustomRating id="rating5" ratings={ratings} setRatings={setRatings} />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item>
                          <Box width={160}>
                            <TextField
                              autoComplete='off'
                              id="rating_password_value"
                              label="密码"
                              size="small"
                              type="password"
                              margin="none"
                              inputRef={rating_password_ref}
                            />
                          </Box>
                        </Grid>
                        
                      </Grid>
                    </Box>
                  </DialogContent>
                }
              </DialogContent>
              <DialogActions>
                <Button onClick={CloseRatingDailog} color="primary">
                  Cancel
                </Button>
                <Button onClick={SubmitRating} color="primary">
                  Submit
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        </PullToRefresh>
        <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleAlertClose}>
            <MuiAlert elevation={6} variant="filled" onClose={handleAlertClose} severity={alert_severity_ref.current}>
              {alert_message_ref.current}
            </MuiAlert>
        </Snackbar>
      </React.Fragment>
    );
}

export default PocketDetails;